import type { CSSProperties } from 'vue';

export const LOGS_SIDEBAR_GAP = 24;

// Measured synchronously, before the first paint: a ResizeObserver reports after it, and the paper
// would rescale right after the screen opens. The probe takes the global thin scrollbar like any
// element.
export function measureScrollbarWidth(): number {
  const probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;visibility:hidden;overflow:scroll;width:100px;height:100px';
  document.body.appendChild(probe);
  const width = probe.offsetWidth - probe.clientWidth;
  probe.remove();
  return width;
}

// The scroll reaches into the gap before the sidebar so its bar sits centred there and the content
// ends on the same edge as the header's view tabs. A bar as wide as the gap (a zoomed out browser)
// would cover the sidebar, so the scroll then stays inside its column.
export function logsScrollGutterStyle(scrollbarWidth: number, gap = LOGS_SIDEBAR_GAP): CSSProperties {
  if (scrollbarWidth >= gap) return {};
  const space = Math.floor((gap - scrollbarWidth) / 2);
  return { marginRight: `-${scrollbarWidth + space}px`, paddingRight: `${space}px` };
}
